import React, { useEffect, useRef, useState } from 'react';
import './Page5.css';
import { useNavigate } from 'react-router-dom';

import playButtonImage from './../assets/commum/button_play.png';
import homeButtonImage from './../assets/commum/button_home.png';
import bgImage from './../assets/commum/bg_geral.png';
import videoSourceEN from './../assets/page5/SEE_AND_SPRAY_EN.mp4';
import videoSourceES from './../assets/page5/SEE_AND_SPRAY_ES.mp4';
import videoSourcePT from './../assets/page5/SEE_AND_SPRAY_PT.mp4';

function Page5_1() {
  const videoRef = useRef(null);
  const navigate = useNavigate();

  const [isPlaying, setIsPlaying] = useState(false);
  const [videoSource, setVideoSource] = useState("");

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  const handleVideoEnd = () => {
    setIsPlaying(false);
    navigate('/page5');
  };

  useEffect(() => {
    const language = window.language;
    if (language === 'EN') {
      setVideoSource(videoSourceEN);
    } else if (language === 'ES') {
      setVideoSource(videoSourceES);
    } else {
      setVideoSource(videoSourcePT);
    }
  }, []);

  useEffect(() => {
    // play the video as soon as it's ready
    const interval = setInterval(() => {
      if (videoRef.current && videoRef.current.readyState >= 3) {
      videoRef.current.play();
      setIsPlaying(true);
      clearInterval(interval);
      }
    }, 100);

  }, [videoSource]);

  return (
    <div className="page5-container" style={{ backgroundImage: `url(${bgImage})` }}>
      <video
        ref={videoRef}
        className="video-player"
        src={videoSource}        
        onEnded={handleVideoEnd}
        width="960"
        height="540"
        style={{ width: '960px', height: '540px' }}
      />
      {!isPlaying && (
        <img
          src={playButtonImage}
          alt="Play Button"
          className="play-button"
          onClick={handlePlay}
        />
      )}
      <div className="back-button" style={{ bottom: '119px', left: '75px', width: '76px', height: '50px' }} onClick={() => navigate('/page5')}>
        <img src={homeButtonImage} alt="Home Button" />
      </div>
    </div>
  );
}

export default Page5_1;
